var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/WbsEnums';
let WbsModule = class WbsModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.loadPage = false;
        // api wbs
        this.wbsList = [];
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.searchBy = '';
        this.paging = [];
        this.status = '';
        this.statusMessage = '';
        this.selectedWbsElement2 = [];
        this.dropdownlistWbsElement2 = [];
    }
    get getWbsElement2WasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getDropdownlistWbsElement2() {
        return this.dropdownlistWbsElement2;
    }
    get getWbsElement2Lists() {
        return this.wbsList;
    }
    get getWbsStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getSelectedWbsElement2() {
        return this.selectedWbsElement2;
    }
    get getWbsPaging() {
        return this.paging;
    }
    get getWbsLoading() {
        return this.loading;
    }
    get getStatusWbs() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getWbsSize() {
        return this.size;
    }
    get getWBSWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getWBSDesc() {
        return this.desc;
    }
    get getWBSSearchBy() {
        return this.searchBy;
    }
    [_a = Mutations.SET_WBS_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_SELECTED_WBS](payload) {
        this.selectedWbsElement2 = payload;
    }
    [_c = Mutations.SET_WBS_LIST](payload) {
        this.wbsList = payload;
    }
    [_d = Mutations.SET_WBS_LOADING](payload) {
        this.loading = payload;
    }
    [_e = Mutations.SET_WBS_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_f = Mutations.SET_WBS_PAGE](payload) {
        this.paging = payload;
    }
    [_g = Mutations.SET_WBS_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_h = Mutations.SET_WBS_STATUS](payload) {
        this.status = payload.statusAssetNumber;
        this.statusMessage = payload.statusMessageAssetNumber;
    }
    [_j = Mutations.SET_DROPDOWNLIST_WBSELEMENT2](payload) {
        this.dropdownlistWbsElement2 = payload;
    }
    [_k = Mutations.SET_WBS_SIZE](payload) {
        this.size = payload;
    }
    [_l = Mutations.SET_WBS_HANDLE_SIZE](payload) {
        this.size = payload;
    }
    [_m = Mutations.SET_WBS_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_o = Mutations.SET_WBS_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_p = Mutations.SET_WBS_DESC](payload) {
        this.desc = payload;
    }
    [_q = Mutations.SET_WBS_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_r = Actions.GET_WBS_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_WBS_LOADING, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingproject/wbsfilter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                wbsElement2: this.selectedWbsElement2
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _w, _x;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_WBS_LIST, ((_w = res.data.result.content) === null || _w === void 0 ? void 0 : _w.data) || []);
                        this.context.commit(Mutations.SET_WBS_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_WBS_PAGE, ((_x = res.data.result.content) === null || _x === void 0 ? void 0 : _x.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        this.context.commit(Mutations.SET_WBS_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_WBS_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_s = Actions.GET_WBS_LIST_ALLDATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_WBS_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const dataListWBSElement = [...this.dropdownlistWbsElement2];
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/mappingproject/wbsfilter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '10',
                Desc: this.desc,
                SearchBy: this.searchBy
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_WBS_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_WBS_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataListWBSElement.push({
                                    value: data.wbsElement2,
                                    label: data.wbsElement2
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_WBS_WAS_LOAD_QUICK_FILTER, false);
                        }
                        this.context.commit(Mutations.SET_DROPDOWNLIST_WBSELEMENT2, dataListWBSElement);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_WBS_WAS_LOAD_QUICK_FILTER, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_WBS_WAS_LOAD_QUICK_FILTER, false);
                    reject(false);
                });
            });
        });
    }
    [_t = Actions.UPDATE_WBS_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_WBS_SIZE, data);
            this.context.commit(Mutations.SET_WBS_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_WBS_LIST);
        });
    }
    [_u = Actions.UPDATE_WBS_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_WBS_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_v = Actions.UPDATE_WBS_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_WBS_SEARCH_BY, data === '' ? '' : 'wbsElement2');
            this.context.commit(Mutations.SET_WBS_DESC, data);
            this.context.commit(Mutations.SET_DROPDOWNLIST_WBSELEMENT2, []);
            this.context.commit(Mutations.SET_WBS_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_WBS_LIST_ALLDATA);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WbsModule.prototype, _q, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], WbsModule.prototype, _r, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], WbsModule.prototype, _s, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], WbsModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], WbsModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], WbsModule.prototype, _v, null);
WbsModule = __decorate([
    Module
], WbsModule);
export default WbsModule;
